import FilterCoverDemo from '@/assets/images/styleFilterMarket/FilterCoverDemoMobile.webp';
import { TrackList } from '@/components/TrackList';
import { Button } from '@/components/ui/button';
import WithMobileHeader from '@/components/WithMobileHeader';
import { getStyleFilterGroupList } from '@/service/filter';
import { useTrackLists } from '@/state/style-filter-list-store';
import { cn } from '@/utils';
import { useRequest } from 'ahooks';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArtistLink } from '../desktop/components/ArtistLink';
import FilterCards from './components/FilterCards';
import MarketHeader from './components/MarketHeader';

export default function StyleFilterMarketplace() {
  const { marketAudioListData } = useTrackLists();
  const trackListRef = useRef<HTMLDivElement>(null);

  const { data: getStyleFilterGroupData } = useRequest(getStyleFilterGroupList);

  const sfDetail = getStyleFilterGroupData?.data?.[0];

  const navigate = useNavigate();

  return (
    <WithMobileHeader>
      <>
        <div className="pt-6 pb-4">
          <MarketHeader trackListRef={trackListRef} />
        </div>
        <div className="pb-4">
          <FilterCards getStyleFilterGroupData={getStyleFilterGroupData} />
        </div>
        <div className="pb-4 px-3">
          <div className="px-6 py-16 bg-[#F6F6F7] rounded-xl">
            <h1 className="text-[32px] text-jen-content-primary tracking-[-0.32px] leading-[30px] mb-6">
              Transform Your Music with StyleFilters™
            </h1>
            <p className="text-[18px] tracking-[-0.32px]">
              <span className="text-[#71717A]">StyleFilters™ are a groundbreaking patented innovation in music creation, </span>
              <span className="text-jen-content-primary">
                allowing users to infuse AI-generated music with the distinct styles of their favorite artists and producers,{' '}
              </span>
              <span className="text-[#71717A]">
                instantly transforming simple prompts into compositions that resonate with personality and depth.
              </span>
            </p>
          </div>
        </div>
        <div className="pb-4">
          <div className="relative overflow-hidden px-4">
            <div className="absolute flex items-center top-4 left-8">
              <ArtistLink artist={sfDetail} textClassName="text-white" avatarClassName="border-white" />
            </div>
            <img src={FilterCoverDemo} alt="Filter Cover Demo" className="w-full h-auto rounded-2xl" />
            <Button
              variant="outline"
              className={cn('absolute bottom-4 left-8 z-10', 'border-2 border-white bg-transparent', 'hover:bg-white/10', 'text-white')}
              style={{
                borderWidth: '1px',
              }}
              onClick={() => {
                navigate(`/marketplace/artist/imogen-heap`);
              }}
            >
              Learn More
            </Button>
          </div>
        </div>
        <div className="p-4" ref={trackListRef}>
          <section className="p-6 bg-jen-background-primary rounded-xl overflow-hidden border border-[#202223]/10 px-4">
            <h2 className="text-[24px] text-[#111112] tracking-[-0.96px] leading-[24px] mb-6">
              Tracks Generated with
              <div>
                <span>Imogen Heap </span>StyleFilters™
              </div>
            </h2>
            <TrackList trackListData={marketAudioListData['IMO-ALL']} />
          </section>
        </div>
      </>
    </WithMobileHeader>
  );
}
